import { render, staticRenderFns } from "./NotifyForm.vue?vue&type=template&id=384d1431&scoped=true&"
import script from "./NotifyForm.vue?vue&type=script&lang=js&"
export * from "./NotifyForm.vue?vue&type=script&lang=js&"
import style0 from "./NotifyForm.vue?vue&type=style&index=0&id=384d1431&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384d1431",
  null
  
)

export default component.exports